export enum SSO_MODAL_CONTENT_STEPS {
  MAGIC_LINK = 'magic_link',
  SIGN_IN = 'sign_in',
  SIGN_UP = 'sign_up',
  WELCOME = 'welcome',
  REGISTER_CARD = 'register_card',
  IFRAME = 'iframe',
}
